import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "vue"
import {
  MissionLifecycleFragmentFragment,
  GenerateClientPaymentStructureMutationMutation,
  GenerateClientPaymentStructureMutationMutationVariables,
  ClientPaymentStructureInput,
  GenerateClientPaymentStructureMutation,
} from "@/gql"
import { useMutation } from "@/hooks/useMutation"
import { useNotification } from "@/hooks/useNotification"

import { RefetchQueryDescription } from "apollo-client/core/watchQueryOptions"
import SetupMissionPaymentForm from "./SetupPaymentForm.vue"
import { SetupPaymentType } from "@/modules/Missions/components/Payment/constant"


export default /*#__PURE__*/_defineComponent({
  __name: 'SetupClientPaymentForm',
  props: {
    value: { type: Boolean },
    mission: null,
    refetchQueries: null
  },
  emits: ["close"],
  setup(__props: any, { emit }) {

const props = __props as {
  value: boolean
  mission: MissionLifecycleFragmentFragment
  refetchQueries: RefetchQueryDescription
}





const { mutate } = useMutation()
const { addSuccess } = useNotification()

const isSubmitting = ref(false)

const showDialog = ref(false)

watch(
  () => props.value,
  (value) => {
    showDialog.value = value
  }
)

const setupMissionPaymentForm = ref<InstanceType<typeof SetupMissionPaymentForm>>()

const onComplete = async (payments: ClientPaymentStructureInput[]) => {
  isSubmitting.value = true

  const result = await mutate<
    GenerateClientPaymentStructureMutationMutation,
    GenerateClientPaymentStructureMutationMutationVariables
  >({
    mutation: GenerateClientPaymentStructureMutation,
    variables: {
      missionLifecycleId: props.mission.prn,
      paymentsInput: payments,
    },
    refetchQueries: props.refetchQueries,
    done: () => {
      isSubmitting.value = false
    },
  })

  if (result && !result?.data?.generateClientPaymentStructure?.error) {
    addSuccess("Payments set up successfully")
    onClose()
  }
}

const onClose = () => {
  setupMissionPaymentForm.value?.resetForm()
  showDialog.value = false
  emit("close")
}

return { __sfc: true,props, emit, mutate, addSuccess, isSubmitting, showDialog, setupMissionPaymentForm, onComplete, onClose, SetupMissionPaymentForm, SetupPaymentType }
}

})